import request from '../utils/request'


export function index(params) {
  	return request({
  	  url: '/dailyTreatmentIndeces',
  	  method: 'get',
        params
  	})
  }
  export function inventory(params) {
    return request({
      url: '/dailyTreatmentIndeces/inventory',
      method: 'get',
      params
    })
  }

export function show(id) {
    return request({
      url: `/dailyTreatmentIndeces/${id}`,
      method: 'get'
    })
  }

  export function store(data) {
    return request({
      url: '/dailyTreatmentIndeces',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/dailyTreatmentIndeces/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/dailyTreatmentIndeces/${id}`,
      method: 'delete',
    })
  }
